import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faEye,
  faPlus,
  faQrcode,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import func, { connectionTransactionalToContact, translateLabel } from "../../../services/functions";
import { Preloader, ThreeDots } from "../../global/Preloader";
import { Link } from "react-router-dom";
import { getStore } from "../../../AppContext";
import TooltipOverlay from '../../global/TooltipOverlay'
import CellInput from "../../global/CellInput";
import { paymentOptions } from "../../../services/data";
import DatePicker from "react-datepicker";
import LoadingLayover from "../../global/LoadingLayover";
import { useTranslation } from "react-i18next";
import { cisStatusList, prioritySortList, statusSortList } from "../Utils";

const moment = require("moment");

const useGeneratePurchasesColumns = ({
  allTcr=[],
  cisStatusOptions,
  internalStatusOptions,
  priorityOptions,
  currencyOptions,
  tcrList=()=>[],
  filters,
  setFilters,
  handleParamsChange,
  getFilteredResults,
  loadingPdf,
  showInvoicePdf,
  loadingIdKey,
  compact = false,
  setContactModal,
  checkUnknownBussiness,
  searchPurchaseTable=false,
}) => {
  
  const { user: [user], company: [fullCompany] } = getStore()
  const { t,i18n } = useTranslation("translations");

  const purchaseRole = user.purchaseRole


  const periodFilter = (filterOptions) => {
    let selected = filters?.params?.["period"]
    return (
        <div>
            <DatePicker
                id="periodDate"
                placeholderText={t("queue.selectDate")}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                portalId="root"
                popperPlacement="bottom-end"
                popperProps={{
                    strategy: "fixed"
                }}
                onChange={(date) => {
                    const selectedDate = new Date(date).setHours(2, 0, 0, 0)
                    filterOptions.filterCallback(selectedDate)
                    const value = moment(selectedDate).format("M/yyyy")
                    const fromDate = moment(selectedDate).startOf("month").set({ hour: 2, minute: 0, second: 0, millisecond: 0 }).toDate()
                    const toDate = moment(selectedDate).endOf("month").set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toDate()
                    if (setFilters) {
                      setFilters((filters) => ({
                        ...filters,
                        fromDate,
                        toDate,
                        params: {
                          ...filters.params,
                          period: value,
                        },
                      }))
                    } else {
                      handleParamsChange(null, "period", value)
                    }
                    getFilteredResults({ data: { ...filters, fromDate, toDate, params: { ...filters.params, "period": value } } })
                }
                }
                customInput={
                    <div className="form-control d-flex justify-content-center align-items-center" style={{ width: 150, position: "relative", cursor: "pointer" }}>
                        <FontAwesomeIcon icon={faCalendar} />
                        <div className="ml-1">
                            {filters?.params?.["period"] ? filters?.params?.["period"] : t("vat.none")}
                        </div>
                        {selected && <div
                            onClick={(e) => {
                                e.stopPropagation()
                                filterOptions.filterCallback("")
                                if (setFilters) {
                                  setFilters((filters) => ({
                                    ...filters,
                                    params: {
                                      ...filters.params,
                                      period: null,
                                    },
                                  }))
                                } else {
                                  handleParamsChange(null, "period", null)
                                }
                                getFilteredResults({ data: { ...filters, params: { ...filters.params, "period": null } } })
                            }}
                            style={{ position: "absolute", zIndex: 99999, top: 6, right: 10, padding: "0px 5px", cursor: "pointer", fontSize: 16, fontWeight: 400 }}>
                            {`\u2715`}
                        </div>}
                    </div>
                }
            />
        </div>
    )
}


  return [
    {
      header: "Status",
      style:{minWidth: "150px",maxWidth:"150px"},
      field: "internalStatus",
      body: invoice => internalStatusOptions.find((option) => option.value === invoice?.internalStatus)?.label ?? invoice?.internalStatus,
      sortFunction:(rowA,rowB)=>func.columnCustomSort(rowA,rowB,statusSortList,"internalStatus"),
      default: searchPurchaseTable ? true : true,
      persisted:true,
      filter: false,
      filterType: "MULTISELECT",
      filterConfig: {
        options: internalStatusOptions,
        showCount: true
      },
      mobile: { priority: 1, isBadge: true, group: "status" },
    },
    {
      header:  t(["purchases.cisStatus"]),
      style:{minWidth: "180px",maxWidth:"180px"},
      field: "purchaseStatus",
      body: invoice => cisStatusOptions.find((option) => option.value === invoice?.purchaseStatus)?.label ?? invoice?.purchaseStatus,
      sortFunction:(rowA,rowB)=>func.columnCustomSort(rowA,rowB,cisStatusList,"purchaseStatus"),
      formattedExportValue: true,
      default: searchPurchaseTable ? true : true,
      filter: false,
      filterType:"MULTISELECT",
      filterConfig:{
        options: cisStatusOptions,
        showCount:true
      },
      mobile: { priority: 2 },
    },

    ...![14,12].includes(purchaseRole.id) ? [{
      header: t(["home.actions"]),
      style:searchPurchaseTable?{minWidth:100,maxWidth:100}:{minWidth: "230px",maxWidth:checkUnknownBussiness?"400px":"230px"},
      field: "actions",
      body: (invoice) => {

        return (
       <div className="d-flex gap-1 w-full">
            {!searchPurchaseTable && <Link
              to={"/edit-purchase/" + invoice.id}
              className={"nav-link p-0 d-flex text-primary align-items-center mr-3"}
            >
              <FontAwesomeIcon icon={faEye} className="mr-1" />
              {t("invoice.view")}
            </Link>}
            <a
                    href={`${invoice?.qr_url}`}
                    target="_blank"
                    className="nav-link p-0 d-flex align-items-center"
                >
                  <FontAwesomeIcon size="lg" className="mr-1" icon={faQrcode} />
                  <div style={{whiteSpace:"nowrap"}}>QR Url</div>
            </a>
           {checkUnknownBussiness && <button className="btn btn-sm text-primary ml-2" style={{minWidth:"120px"}} onClick={()=>{const contact = connectionTransactionalToContact({connection:invoice?.connectionTransactional});setContactModal({visible:true,contact,invoiceId:invoice?.id})}}>
            <FontAwesomeIcon className="mr-1" icon={faPlus} />
            Add Contact
            </button>}
          </div>
        )
      },
      persisted: true,
      mobile: { priority: "action", group: "actions" },
    }]:[],

    {
      header: t("purchases.supplierName"),
      style:{minWidth: "220px",maxWidth:"220px"},
      field:"connectionTransactional.name",
      format: (invoice) =>invoice?.connectionTransactional?.name ?? "",
      body: (invoice) => {
          return invoice?.connectionTransactional?.name ?? ""
      },
      sortable:true,
      default: searchPurchaseTable ? true : true,
      filter:true,
      filterConfig:{
        splitKey:false
      },
      mobile: { priority: 1, isTitle: true, group: "identity" },
    },
    {
      header: t("invoice.sellerNuis"),
      field: "sellerTin",
      style:{minWidth: "180px",maxWidth:"180px"},
      default: searchPurchaseTable ? true : true,
      filter: true,
      filterConfig: {
        like:true,
        disabled:searchPurchaseTable,
        filterKey:searchPurchaseTable
      },
      mobile: { priority: 1, group: "identity" },
    },
    {
      header: t(["invoice.print"]),
      field: 'print',
      style:{minWidth: "70px",maxWidth:"70px"},
      body: invoice => {
        const isLoadingPdf=loadingPdf?.id==invoice?.[loadingIdKey] && loadingPdf?.loading
        const src=!invoice.einvoice ?"https://profisc.al/wp-content/uploads/2021/10/Asset-11.svg":"https://profisc.al/wp-content/uploads/2021/10/Asset-12.svg"

        return (
        <div className="d-flex gap-1">
             <a
            href="#"
            className={
                "nav-link p-0 d-flex-align-items-center mr-1"
            }
            onClick={(e) =>  showInvoicePdf({key:'attachmentByte', invoice,e}) }>
            <LoadingLayover loading={(isLoadingPdf && (loadingPdf?.key==="attachmentByte")) }>
              <img
                  src={src}
                  width={compact?30:38}
                  height={compact?24:32}
              />
            </LoadingLayover>

            </a>
          {/* */}
        </div>)
      },
      default: searchPurchaseTable ? true : true,
      mobile: { priority: "action", group: "actions" },
    },
    {
      header: t(["table.issueDatetime"]),
      field: "recordDateTime",
      style:{minWidth: "180px",maxWidth:"180px"},
      sortable: true,
      formattedExportValue: true,
      body: (invoice) =>
        invoice.recordDateTime
          ? moment(invoice.recordDateTime).format("DD/MM/YYYY HH:mm")
          : "",
      default: searchPurchaseTable ? true : true,
      filter: true,
      filterConfig:{
        like:false
      },
      filterType:"DATE",
      mobile: { priority: 1, group: "dates" },
    },
    {
      header: t(["invoice.extracted"]),
      style:{minWidth: "100px",maxWidth:"100px"},
      field: "extracted",
      format: (invoice) => (invoice?.purchaseInvoiceExtracted?.extracted ? invoice?.purchaseInvoiceExtracted?.extracted  : ""),
      body: (row) =>
        row.extracted ? (
          <div className="ml-3 text-success font-weight-bold">
            {t("company.yes")}
          </div>
        ) : (
          <div className="ml-3 text-danger font-weight-bold">
            {t("company.no")}
          </div>
        ),
      filter: true,
      filterType:"TRISTATECHECKBOX",
      default: searchPurchaseTable ? false : false,
      mobile: { priority: 2 },
    },
    {
      header: t(["home.totAll"]),
      style:{minWidth:"170px",maxWidth:"170px"},
      field: "amountInAll",
      sortable: true,
      body: (invoice) =>  invoice.amountInAll ? func.getFormattedMoneyValue(invoice.amountInAll) : 0,
      default: searchPurchaseTable ? false : true,
      align:"right",
      filter: searchPurchaseTable ? true : false,
      mobile: { priority: 1, group: "financial" },
    },

    {
      header: t(["home.totCurrency"]),
      style:{minWidth:"170px",maxWidth:"170px"},
      field: "amount",
      sortable: true,
      formattedExportValue:true,
      body: (invoice) =>  invoice.amount ? func.getFormattedMoneyValue(invoice.amount) : 0,
      default: searchPurchaseTable ? false : true,
      align:"right",
      filter: searchPurchaseTable ? false : false,
      mobile: { priority: 2, group: "financial" },
    },

    {
      header: t(["home.exchangeRate"]),
      style:{minWidth:"140px",maxWidth:"140px"},
      field: "exRate",
      default: searchPurchaseTable ? true : true,
      mobile: { priority: 3 },
    },
    {
      header: t(["invoice.currency"]),
      style:{minWidth: "100px",maxWidth:"100px"},
      field: "currency",
      body: (invoice) => (invoice?.currency ? invoice?.currency  : ""),
      default: searchPurchaseTable ? true : true,
      filter: false,
      filterType: "MULTISELECT",
      filterConfig: {
        options: currencyOptions,
        showCount: true
      },
      mobile: { priority: 2, group: "financial" },
    },
    {
      header: t("purchases.activities"),
      style:{minWidth: "140px",maxWidth:"140px"},
      field:"purchaseApprovals",
      format:()=>"",
      body: (invoice) =>{
        let rejections=invoice?.purchaseApprovals?.reduce((sum,invoice)=>sum+invoice?.rejections,0)
        let approvals=invoice?.purchaseApprovals?.reduce((sum,invoice)=>sum+invoice?.approvals,0)
        let returnCount=invoice?.purchaseApprovals?.reduce((sum,invoice)=>sum+invoice?.resetNr,0);
        
        return (
          <div className="d-flex">
            {returnCount>0 &&  <TooltipOverlay show={20} hide={20} title="Returns"><div className={`p-1 badge badge-warning mr-3`} style={{cursor:"pointer"}}> { returnCount }</div></TooltipOverlay>}
            {rejections>0 &&  <TooltipOverlay show={20} hide={20} title="Rejections"><div className={`p-1 badge badge-danger mr-3`} style={{cursor:"pointer"}}> { rejections }</div></TooltipOverlay>}
            {approvals>0 &&  <TooltipOverlay show={20} hide={20} title="Approvals"><div className={`p-1 badge badge-success mr-3`} style={{cursor:"pointer"}}> { approvals }</div></TooltipOverlay>}
          </div>
        )
      },
      mobile: { priority: 2 },
    },
    {
      header: t(["invoice.docNumber"]),
      field: "docNumber",
      style:{minWidth: "180px",maxWidth:"180px"},
      sortable:true,
      formattedExportValue:true,
      format: (invoice)=>func?.preventExcelFormatFn(invoice?.docNumber || ""),
      body: (invoice) => invoice?.docNumber || "",
      default: searchPurchaseTable ? true : true,
      filter: true,
      filterConfig: {like: searchPurchaseTable ? false : true},
      mobile: { priority: 1, group: "identity" },
    },
    {
      header: t("invoice.priority"),
      field: "priority",
      style:{minWidth: "120px",maxWidth:"120px"},
      body: (invoice) =>invoice?.priority ?? "",
      sortFunction:(rowA,rowB)=>func.columnCustomSort(rowA,rowB,prioritySortList,"priority"),    
      filter: true,
      filterType: "MULTISELECT",
      filterConfig: {
        options: priorityOptions,
        showCount: true,
        like:false
      },
      mobile: { priority: 2 },
    },
    {
      header: "EIC",
      field: "eic",
      style:{minWidth: "180px",maxWidth:"180px"},
      body: invoice => <CellInput value={invoice?.eic} width={180}/>,
      default:true,
      filter:true,
      filterConfig:{
        like:true
      },
      mobile: { priority: 2, group: "reference" },
    },
    {
      header: t("invoice.IIC"),
      field: "iic",
      style:{minWidth: "180px",maxWidth:"180px"},
      body: invoice => <CellInput value={invoice?.iic} width={180}/>,
      filter: true,
      mobile: { priority: 2, group: "reference" },
    },
    {
      header: t("invoice.FIC"),
      field: "fic",
      style:{minWidth: "180px",maxWidth:"180px"},
      format:invoice=>invoice?.fic,
      body: invoice => <CellInput value={invoice?.fic} width={180} />,
      filter: searchPurchaseTable ? true : true,
      default: searchPurchaseTable ? true : false,
      mobile: { priority: 2, group: "reference" },
    },
    {
      header: t("purchases.purchaseUnit"),
      style:{minWidth: "180px",maxWidth:"180px"},
      field: "purchaseUnit",
      format: (invoice) =>allTcr?.find(tcr=>tcr.value===invoice?.purchaseUnit)?.label??"",
      body: invoice => (<CellInput value={allTcr?.find(tcr => tcr.value === invoice?.purchaseUnit)?.label ?? ""} width={180} />),
      default: searchPurchaseTable ? true : true,
      filter: searchPurchaseTable ? true : true,
      filterType:"MULTISELECT",
      filterConfig:{
        options: tcrList(),
        value: tcrList()?.filter((tcr) =>
          filters?.params?.purchaseUnit?.find(
            (tcrValue) => tcrValue === tcr.value
          )
        )?.map(opt => opt.value) || "",
        searchable:true
      },
      mobile: { priority: 2 },
    },
    {
      header: t("invoice.supplierCode"),
      style:{minWidth: "180px",maxWidth:"180px"},
      field: "supplierCode",
      filter: true,
      filterConfig:{
        like:true
      },
      mobile: { priority: 3 },
    },
    ...fullCompany?.workflow?.id == 2 ? [{
      header: t("purchases.dispatchUser"),
      style: { minWidth: "140px", maxWidth: "140px" },
      field: "dispatcherUser",
      filter:true,
      filterConfig:{
        like:true
      },
      default: true,
      mobile: { priority: 3 },
    }]:[],
    {
      header: t("purchases.approveRejectUser"),
      style:{minWidth:"180px",maxWidth:"180px"},
      field: "acceptRejectUser",
      default:true,
      filter:true,
      filterConfig:{
        like:true
      },
      mobile: { priority: 3 },
    },
    {
      header:  t("invoice.agreementNo"),
      field: "agreement",
      filter: true,
      filterConfig:{
        like:true
      },
      style:{minWidth: "190px",maxWidth:"190px"},
      mobile: { priority: 3 },
    },
    {
      header: t("purchases.agreementDate"),
      field: "agreementDate",
      filter: true,
      filterConfig:{
        like:false
      },
      style:{minWidth: "180px",maxWidth:"180px"},
      formattedExportValue: true,
      body: invoice => {let date=invoice.agreementDate; return date? moment( date ).format("DD/MM/YYYY") : ""},
      filterType:"DATE",
      mobile: { priority: 3 },
    },
    {
      header: t("purchases.poNo"),
      field: "internalPo",
      filter: true,
      filterConfig:{
        like:true
      },
      preventExcelFormat:true,
      style:{minWidth: "150px",maxWidth:"150px"},
      mobile: { priority: 3 },
    },
    {
      header: t("purchases.poDate"),
      field: "internalPoDate",
      filter:true,
      filterConfig:{
        like:false
      },
      style:{minWidth: "150px",maxWidth:"150px"},
      formattedExportValue: true,
      body: invoice => {let date=invoice?.internalPoDate;return date? moment(date).format("DD/MM/YYYY HH:mm") : ""},
      filterType:"DATE",
      mobile: { priority: 3 },
    },
    {
      header: t("purchases.paymentDatePurchases"),
      field: "dueDateTime",
      style:{minWidth: "170px",maxWidth:"170px"},
      sortable: true,
      formattedExportValue: true,
      body: invoice => invoice.dueDateTime ? moment(invoice.dueDateTime).format("DD/MM/YYYY") : "",
      default: searchPurchaseTable ? true : false,
      filter: searchPurchaseTable ? true : true,
      filterConfig:{
        like:false
      },
      filterType: "DATE",
      mobile: { priority: 2, group: "dates" },
    },
    {
      header: t("purchases.expectedPayment"),
      field: "paymentRequestedDate",
      style:{minWidth: "200px",maxWidth:"200px"},
      formattedExportValue: true,
      body: invoice => {let date=invoice?.paymentRequestedDate;return date ? moment(date).format("DD/MM/YYYY") : ""},
      mobile: { priority: 3 },
    },
    {
      header: t("purchases.expectedAcceptanceDate"),
      field: "expectedAcceptanceDate",
      style:{minWidth: "220px",maxWidth:"220px"},
      formattedExportValue: true,
      body: invoice => invoice?.expectedAcceptanceDate ? moment(invoice?.expectedAcceptanceDate).format("DD/MM/YYYY") : "",
      mobile: { priority: 3 },
    },
    {
      field:"internalPaymentStatus",
      header:t("openBanking.paymentStatus"),
      style: { minWidth: 200, maxWidth: 300 },
      mobile: { priority: 2 },
    },
    {
      header: t("invoice.receivedDate"),
      field: "recordDate",
      style:{minWidth: "220px",maxWidth:"220px"},
      formattedExportValue: true,
      body: invoice => invoice?.recordDate ? moment(invoice?.recordDate).format("DD/MM/YYYY") : "",
      mobile: { priority: 3 },
    },
    {
      field:"paymentType",
      header:"Cash/NonCash",
      style: { minWidth: "150px", maxWidth: "150px" },
      filter:true,
      filterType:"DROPDOWN",
      filterConfig:{
        options: paymentOptions,
        like:false
      },
      mobile: { priority: 2 },
    },
    {
      field:"impCustDecNum",
      header:t("books.impCustDecNum"),
      style: { minWidth: "200px", maxWidth: "200px" },
      filter:true,
      mobile: { priority: 3 },
    },
    // {
    //   field:"einvoice",
    //   header:"E-Invoice",
    //   style: { minWidth: "120px", maxWidth: "120px" },
    //   dataType:"boolean",
    //   filter:true,
    //   filterType:"TRISTATECHECKBOX",
    //   filterConfig:{
    //     field:"isEinvoice"
    //   }
    // },
    {
      header: t("queue.period"),
      style: { minWidth: "180px", maxWidth: "180px" },
      field: 'period',
      default: true,
      format: (invoice)=>func?.preventExcelFormatFn(invoice?.period || ""),
      filter: true,
      filterElement: periodFilter,
      mobile: { priority: 2 },
    },
    {
      field: "iicRef",
      header: t("purchases.iicRef"),
      style: { minWidth: 200, maxWidth: 300 },
      filter: true,
      mobile: { priority: 3 },
  },
    {
      field: "dateRef",
      header: t("purchases.correctiveInvoiceDate"),
      style: { minWidth: 200, maxWidth: 300 },
      formattedExportValue: true,
      body: invoice => invoice?.dateRef ? moment(invoice?.dateRef).format("DD/MM/YYYY") : "",
      filter: true,
      mobile: { priority: 3 },
    },
    ...(fullCompany?.showMyPurchaseDownloadedStatus ? [{
      header: t(["invoice.apiDownloaded"]),
      style:{minWidth: "180px",maxWidth:"180px"},
      field: "downloaded",
      format: (invoice) => (invoice?.downloaded ?? ""),
      body: (row) =>
          row.downloaded ? (
              <div className="ml-3 text-success font-weight-bold">
                {t("company.yes")}
              </div>
          ) : (
              <div className="ml-3 text-danger font-weight-bold">
                {t("company.no")}
              </div>
          ),
      mobile: { priority: 3 },
    }]:[]
    ),
  ];
};

export default useGeneratePurchasesColumns;
